<template>
    <slot></slot>
</template>

<script lang="ts">
import { Options } from 'vue-class-component';
import {Vue} from 'vue-class-component';

@Options({
    name:'Text',
    components: {},
    inheritAttrs:false,
    props: {
    }
})

export default class Text extends Vue {
}
</script>
